module.exports = __webpack_public_path__ + "static/media/Real-Time Tracking.373becb1.svg";